<template>
  <div
    v-if="state && state.state && state.results"
    :class="suit()"
  >
    <slot v-bind="stateResults">
      <p>
        Use this component to have a different layout based on a certain state.
      </p>
      <p>Fill in the slot, and get access to the following things:</p>
      <pre>results: {{ Object.keys(state.results) }}</pre>
      <pre>state: {{ Object.keys(state.state) }}</pre>
      <pre>status: {{ state.status }}</pre>
      <pre>error: {{ state.error }}</pre>
    </slot>
  </div>
</template>

<script setup>
import { ref, computed, watch, onBeforeUnmount } from 'vue'
import { useConnector } from '@/composables'

const props = defineProps({
  catchError: { type: Boolean, default: false }
})

const { instantSearchInstance, parent, state, widget } = useConnector({ connector: true, props })

const stateResults = computed(() => {
  const { results, state, status, error } = this.state
  return { ...results, results, state, status, error }
})

const errorFn = ref(() => {})
const renderFn = ref(() => {
  const { status, error } = instantSearchInstance.value
  const results = parent.getResults()
  const helper = parent.getHelper()
  state.value = helper ? helper.state : null

  // @MAJOR no longer spread this inside `results`
  state.value = { results, state, status, error }
})
instantSearchInstance.addListener('render', renderFn.value)
renderFn.value()

watch(() => props.catchError, val => {
  if (val) {
    errorFn.value = () => {}
    instantSearchInstance.addListener('error', errorFn.value)
  } else if (errorFn.value) {
    instantSearchInstance.removeListener('error', errorFn.value)
    errorFn.value = undefined
  }
})

onBeforeUnmount(() => {
  if (widget.value) {
    state.value.instantSearchInstance.removeListener('render', renderFn.value)
    if (errorFn.value) {
      state.value.instantSearchInstance.removeListener('error', errorFn.value)
    }
  }
})

</script>
